<template>
  <div class="imageLayout" :style="styleObject">
    <div class="image1" v-if="imageListCopy.length == 1">
      <div
        class="Home-item1 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="FirstImgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            style="border-radius: 20px"
            mode="aspectFill"
          />

          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px; width: 350px; height: 350px"
          ></video>
        </div>
      </div>
    </div>
    <div
      class="image2"
      v-else-if="imageList.length == 2 && imageList.length > 1"
    >
      <div
        class="Home-item2 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            style="border-radius: 20px"
            mode="aspectFill"
            @click="onPrediv(items)"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
      </div>
    </div>
    <div
      class="image3"
      v-else-if="imageList.length == 3 && imageList.length > 1"
    >
      <div
        class="Home-item3 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            style="border-radius: 20px"
            mode="aspectFill"
            @click="onPrediv(items)"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
      </div>
    </div>
    <div class="image4" v-else-if="imageListCopy.length == 4">
      <div
        class="Home-item4 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            style="border-radius: 20px"
            mode="aspectFill"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
      </div>
    </div>
    <div class="image5" v-else-if="imageListCopy.length == 5">
      <div
        class="Home-item5 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            style="border-radius: 20px"
            mode="aspectFill"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
      </div>
    </div>
    <div class="image6" v-else-if="imageListCopy.length == 6">
      <div
        class="Home-item6 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            mode="aspectFill"
            style="border-radius: 20px"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
        <!--  -->
      </div>
    </div>
    <div class="image7" v-else-if="imageListCopy.length == 7">
      <div
        class="Home-item7 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            mode="aspectFill"
            style="border-radius: 20px"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
        <!--  -->
      </div>
    </div>
    <div class="image8" v-else-if="imageListCopy.length == 8">
      <div
        class="Home-item8 Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            crossorigin="anonymous"
            mode="aspectFill"
            style="border-radius: 20px"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
        <!--  -->
      </div>
    </div>
    <div class="Home-box" v-else>
      <div
        class="Home-item"
        v-for="(items, index) in imageListCopy"
        :key="index"
      >
        <div class="imgBox">
          <img
            v-if="items.type == 'image'"
            :src="
              items.src + '?x-oss-process=style/imgset&&' + new Date().getTime()
            "
            mode="aspectFill"
            crossorigin="anonymous"
            style="border-radius: 20px"
          />
          <video
            @click="play('video' + items._id)"
            poster="../assets/videoCover.jpg"
            :id="'video' + items._id"
            :src="items.src"
            controls
            v-if="items.type == 'video'"
            style="border-radius: 20px"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    downLoadFlag: false,
  },
  data() {
    return {
      styleObject: {
        width: "92%",
        height: "691px",
        position: "absolute",
        left: "0",
        right: "0",
        top: "-5%",
        bottom: "0",
        margin: "auto",
      },
    };
  },
  computed: {
    imageListCopy() {
      if (!this.downLoadFlag) {
        return this.imageList;
      } else {
        let filt = this.imageList.filter((item) => {
          return item.type == "image";
        });
        return filt;
      }
    },
  },
  created() {},
  methods: {
    play(id) {
      let video = document.getElementById(id);
      video.setAttribute("controls", true);
      video.play();
    },
  },
};
</script>

<style lang="less" scoped>
.imageLayout {
  width: 92%;
  height: 691px;
  position: absolute;
  left: 0;
  right: 0;
  top: -15%;
  bottom: 0;
  margin: auto;

  .Home-item {
    width: calc(100% / 3 - 20px);
    height: 200px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    flex-direction: column;
    position: relative;
    background: url(../assets/border-cart.png) no-repeat;
    background-size: 100% 100%;
    padding: 15px 15px;
    box-sizing: border-box;
    overflow: hidden;

    .imgBox {
      border-radius: 20px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      img,
      video {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .Home-item1 > .FirstImgBox {
    width: 660px;
    height: 680px;
  }
  .FirstImgBox {
    width: 350px;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: auto !important;
      height: auto !important;
      max-width: 100% !important;
      max-height: 100% !important;
    }
  }
  .Home-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
  }

  .image2,
  .image3,
  .image6 {
    width: 100%;
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    position: relative;
  }
  .image4 {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .image5 {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .image7,
  .image8 {
    width: 100%;
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    position: relative;
  }
  .Home-item2,
  .Home-item3,
  .Home-item6,
  .Home-item7,
  .Home-item8 {
    position: absolute;
  }
  // 一个图片的
  .image1 > .Home-item1 {
    width: 800px;
    height: 800px;
    top: -95px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .image2 > .Home-item2:nth-child(1) {
    width: 350px;
    height: 350px;
    top: 0;
    left: 60px;
  }

  .image2 > .Home-item2:nth-child(2) {
    width: 350px;
    height: 350px;
    top: 185px;
    right: 80px;
  }

  // 三个图片的样式
  .image3 > .Home-item3:nth-child(1) {
    width: 350px;
    height: 350px;
    top: 0;
    left: 60px;
  }

  .image3 > .Home-item3:nth-child(3) {
    width: 350px;
    height: 350px;
    top: 185px;
    right: 80px;
  }

  .image3 > .Home-item3:nth-child(2) {
    width: 350px;
    height: 350px;
    top: 367px;
    left: 60px;
    // background-image: url(../../static/image/border-cart2.png);
  }

  // 六个图片的样式

  .image6 > .Home-item6:nth-child(1) {
    width: 220px;
    height: 220px;
    top: 0;
    left: 60px;
  }

  .image6 > .Home-item6:nth-child(5) {
    width: 220px;
    height: 220px;
    top: 480px;
    left: 350px;
  }

  .image6 > .Home-item6:nth-child(4) {
    width: 350px;
    height: 350px;
    top: 0px;
    right: 135px;
  }

  .image6 > .Home-item6:nth-child(2) {
    width: 220px;
    height: 220px;
    top: 237px;
    left: 60px;
  }

  .image6 > .Home-item6:nth-child(3) {
    width: 220px;
    height: 220px;
    top: 480px;
    left: 60px;
  }

  .image6 > .Home-item6:nth-child(6) {
    width: 220px;
    height: 220px;
    top: 480px;
    right: 40px;
  }

  .image7 > .Home-item7:nth-child(1) {
    width: 220px;
    height: 220px;
    top: 0;
    left: 60px;
  }

  .image7 > .Home-item7:nth-child(2) {
    width: 200px;
    height: 220px;
    top: 480px;
    left: 300px;
  }

  .image7 > .Home-item7:nth-child(3) {
    width: 350px;
    height: 350px;
    top: 0px;
    right: 135px;
  }

  .image7 > .Home-item7:nth-child(4) {
    width: 220px;
    height: 220px;
    top: 237px;
    left: 60px;
  }

  .image7 > .Home-item7:nth-child(5) {
    width: 220px;
    height: 220px;
    top: 480px;
    left: 60px;
  }

  .image7 > .Home-item7:nth-child(6) {
    width: 200px;
    height: 220px;
    top: 480px;
    right: -18px;
  }
  .image7 > .Home-item7:nth-child(7) {
    width: 200px;
    height: 220px;
    top: 480px;
    right: 191px;
  }
  .image8 > .Home-item8:nth-child(1) {
    width: 300px;
    height: 300px;
    top: 0;
    left: 0;
  }
  .image8 > .Home-item8:nth-child(2) {
    width: 300px;
    height: 300px;
    top: 0;
    left: 316px;
  }
  .image8 > .Home-item8:nth-child(3) {
    width: 260px;
    height: 200px;
    top: 0;
    right: 0;
  }
  .image8 > .Home-item8:nth-child(4) {
    width: 260px;
    height: 200px;
    top: 210px;
    right: 0;
  }
  .image8 > .Home-item8:nth-child(5) {
    width: 260px;
    height: 200px;
    top: 310px;
    left: 0;
  }
  .image8 > .Home-item8:nth-child(6) {
    width: 260px;
    height: 200px;
    top: 525px;
    left: 0;
  }
  .image8 > .Home-item8:nth-child(8) {
    width: 300px;
    height: 280px;
    top: 428px;
    right: 0;
  }
  .image8 > .Home-item8:nth-child(7) {
    width: 300px;
    height: 280px;
    top: 428px;
    right: 320px;
  }
  .image4 > .Home-item4 {
    width: 320px;
    height: 320px;
  }
  .image5 > .Home-item5:nth-child(1) {
    width: 350px;
    height: 350px;
  }
  .image5 > .Home-item5:nth-child(2) {
    width: 350px;
    height: 350px;
  }
  .image5 > .Home-item5:nth-child(3) {
    height: 320px;
  }
  .image5 > .Home-item5:nth-child(4) {
    height: 320px;
  }
  .image5 > .Home-item5:nth-child(5) {
    height: 320px;
  }
}

video {
  width: 100%;
  height: 98%;
  object-fit: contain;
}
</style>
